export type SupportedGTMEvents = 'cookie_consent_granted' | 'cookie_consent_rejected'

export const triggerGTMEvent = (event: SupportedGTMEvents): void => {
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push({ event })
}
